import { Arrow } from "../../Icons";
import style from "./index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const SortVehicles = ({ groups, setSortData }: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <div className={style.sorting}>
      <p>{locale("sort_by")}:</p>
      {groups.map((group, index) => (
        <div key={index} className={style.sorting_group}>
          <span>{group.name}</span>
          {group.buttons.map((button, index) => (
            <button
              key={index}
              type="button"
              className={button.active ? style.active : ""}
              onClick={() => setSortData(button.name[0], !button.active ? button.name[1] : "none")}
            >
              <Arrow color="#000" width="10" height="15" direction={button.name[1] === "asc" ? "up" : "down"} />
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SortVehicles;

export type ComponentPropsType = {
  groups: {
    name: string;
    buttons: {
      active: boolean;
      name: [string, "asc" | "desc"];
    }[];
  }[];
  setSortData: CallableFunction;
};
